import { render, staticRenderFns } from "./SceneSimple.vue?vue&type=template&id=609d233c&scoped=true&"
import script from "./SceneSimple.vue?vue&type=script&lang=js&"
export * from "./SceneSimple.vue?vue&type=script&lang=js&"
import style0 from "./SceneSimple.vue?vue&type=style&index=0&id=609d233c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d233c",
  null
  
)

export default component.exports